import { useLocation } from 'react-router';
import { connect, useDispatch } from 'react-redux';
import get from 'lodash/get';
import FlowRenderer from '../../common/FlowRenderer';
import { buildUseCaseActions } from '../../store/reducers/build-usecases';
import { useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { pageActions } from '../../store/reducers/page-actions';

const UseCaseFlow = ({ isUseCaseDataLoading, selectedUseCase, readonly }: any) => {
  const dispatch = useDispatch();
  const { useCaseId } = useParams();
  const { pathname } = useLocation();

  const onDataRequest = () => {
    dispatch(buildUseCaseActions.getUseCaseDataRequest(useCaseId));
  };

  useEffect(() => {
    const id: any = useCaseId;
    if (id) {
      dispatch(buildUseCaseActions.getUseCaseDataRequest(id));
    }
    return ()=>{
      dispatch(buildUseCaseActions.resetSelectedUseCase());  
    }  
  }, [useCaseId])

  useEffect(() => {
    if (pathname.length) {
      const pathnamesTemp: any = pathname.split('/').filter(Boolean);
      if (pathnamesTemp.length) {        
        const pathnamesData: any = pathnamesTemp          
          .map((item: any, index: number) => {
            if (index == 0) {
              return { route: pathnamesTemp[0], pathName: item, navigate: true };
            } else if (index == 1) {
              return { route: '', pathName: selectedUseCase?.use_case_name, navigate: false };
            } else {
              return { route: '', pathName: item, navigate: false };
            }
          });
        dispatch(pageActions.setPagePath(pathnamesData));
        return () => {
          const data: any = [];
          dispatch(pageActions.setPagePath(data));
        };
      }
    }
  }, [selectedUseCase])

  return (
    <FlowRenderer
      rowTitle={selectedUseCase?.use_case_name || ''}
      onDataRequest={onDataRequest}
      rowId={selectedUseCase?.use_case_id || ''}
      selectedRow={selectedUseCase}
      readonly={readonly}
      useCase={true}
      isSelectedRowLoading={isUseCaseDataLoading}
    />
  );
};

const mapStateToProps = (state: any) => ({
  isUseCaseDataLoading: state.buildUseCase.isUseCaseDataLoading,
  selectedUseCase: state.buildUseCase.selectedUseCase,
});

export default connect(mapStateToProps)(UseCaseFlow);
